export default [
  {
    path: '/main/os',
    meta: {
      tag: 'list_os',
      name: 'Ordens de serviço',
      breadcrumb: 'Ordens de serviço'
    },
    component: () => import(/* webpackChunkName: "os-list" */ '@/views/main/os/Index.vue'),
    children: [
      {
        path: '',
        name: 'listos',
        meta: {
          tag: 'list_os',
          name: 'Ordens de serviço',
          menu: 'os'
        },
        component: () => import(/* webpackChunkName: "os-list" */ '@/views/main/os/List.vue')
      },
      {
        path: 'add',
        name: 'addos',
        meta: {
          tag: 'add_os',
          name: 'Adicionar | Ordem de serviço',
          breadcrumb: 'Adicionar Ordem de serviço',
          menu: 'os'
        },
        component: () => import(/* webpackChunkName: "os-add" */ '@/views/main/os/Add.vue')
      },
      {
        path: 'edit/:id',
        name: 'editos',
        meta: {
          tag: 'edit_os',
          name: 'Editar | Ordem de serviço',
          breadcrumb: 'Editar Ordem de serviço',
          menu: 'os'
        },
        component: () => import(/* webpackChunkName: "os-edit" */ '@/views/main/os/Edit.vue')
      },
      {
        path: 'preview/:id',
        name: 'previewos',
        meta: {
          tag: 'show_os',
          name: 'Visualizar | Ordem de serviço',
          breadcrumb: 'Visualizar Ordem de serviço',
          menu: 'os'
        },
        component: () => import(/* webpackChunkName: "os-preview" */ '@/views/main/os/Preview.vue')
      }
    ]
  }
]
